import {
  ACCACCOUNTCLOSE_LOADING,
  GET_ACCACCOUNTCLOSE,
  GET_ACCACCOUNTCLOSE_SUCCESS,
  GET_ACCACCOUNTCLOSE_FAIL,
  ADD_ACCACCOUNTCLOSE_SUCCESS,
  ADD_ACCACCOUNTCLOSE_FAIL,
  DELETE_ACCACCOUNTCLOSE_SUCCESS,
  DELETE_ACCACCOUNTCLOSE_FAIL,
  UPDATE_ACCACCOUNTCLOSE_SUCCESS,
  UPDATE_ACCACCOUNTCLOSE_FAIL,
  ACCACCOUNTCLOSE_RESET,
  ACCACCOUNTCLOSE_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  accAccountCloses: [],
  accAccountCloseAdded: {},
  error: {},
};

const AccAccountClose = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACCACCOUNTCLOSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCACCOUNTCLOSE:
          return {
            ...state,
            accAccountCloses: action.payload.data,
            isAccAccountCloseCreated: false,
            isAccAccountCloseSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ACCACCOUNTCLOSE_FAIL:
      switch (action.payload.actionType) {
        case GET_ACCACCOUNTCLOSE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAccAccountCloseCreated: false,
            isAccAccountCloseSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ACCACCOUNTCLOSE: {
      return {
        ...state,
        isAccAccountCloseCreated: false,
        loading: true,
      };
    }

    case ACCACCOUNTCLOSE_LOADING: {
      return {
        ...state,
        isAccAccountCloseCreated: false,
        loading: true,
      };
    }

    case ADD_ACCACCOUNTCLOSE_SUCCESS:
      return {
        ...state,
        isAccAccountCloseCreated: true,
        loading: false,
        accAccountCloses: [action.payload.data, ...state.accAccountCloses],
        accAccountCloseAdded: action.payload.data,
      };

    case ADD_ACCACCOUNTCLOSE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ACCACCOUNTCLOSE_SUCCESS:
      return {
        ...state,
        loading: false,
        accAccountCloses: state.accAccountCloses.filter(
          accAccountClose => accAccountClose.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ACCACCOUNTCLOSE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ACCACCOUNTCLOSE_SUCCESS:
      return {
        ...state,
        loading: false,
        accAccountCloses: state.accAccountCloses.map(accAccountClose =>
          accAccountClose.id.toString() === action.payload.data.id.toString() ? { ...accAccountClose, ...action.payload.data } : accAccountClose
        ),
      };

    case UPDATE_ACCACCOUNTCLOSE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACCACCOUNTCLOSE_RESET_CREATE:
      return {
        ...state,
        isAccAccountCloseCreated: false,
      };

    case ACCACCOUNTCLOSE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AccAccountClose;